import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IItemTypeDropdown, IItemTypeState } from "../../../types/item/ItemTypes";

export const initialState: IItemTypeState = {
  itemTypeDropdown: []
};

export const itemTypeSlice = createSlice({
  name: 'itemType',
  initialState,
  reducers: {
    loadingItemTypeDropdown: (state, action: PayloadAction<IItemTypeDropdown[]>) => {
      state.itemTypeDropdown = action.payload;
    },
  }
});

export const { loadingItemTypeDropdown } = itemTypeSlice.actions;

export default itemTypeSlice.reducer;
